import type React from 'react';
import type { ICustomDotProps, PhaseData, IChartCurveProps } from '@/components/phasesCurve/interfaces.ts';
import { PhaseTypes, PhaseCurveDotRadius } from '@/components/phasesCurve/interfaces.ts';
import { curveColorId } from '@/components/phasesCurve/phaseCurve.config.ts';
import * as Recharts from 'recharts';
import { CustomDot } from '@/components/phasesCurve/components/customDot.tsx';
import type { DotProps } from 'recharts';
import { $diastoleColor, $systoleColor } from '@/assets/branding/branding.constants.ts';

export const getChartCurve = ({
  phasesData,
  isImagesLoadingCompleted,
  grabbedReferenceLine,
  isReferenceLinePicked,
  theme
}: IChartCurveProps): React.ReactElement => {
  const availablePhases = phasesData.map((p) => p.phase);
  const minPhase = Math.min(...availablePhases);
  const maxPhase = Math.max(...availablePhases);
  return (
    <>
      <defs>
        <linearGradient id={curveColorId} x1="0%" x2="100%" y1="0" y2="0">
          {phasesData.map((data: PhaseData, i: number) => {
            const normalizedOffset = ((data.phase - minPhase) / (maxPhase - minPhase)) * 100;
            return (
              <stop
                key={i}
                offset={`${normalizedOffset}%`}
                stopColor={data.type === PhaseTypes.Systole ? $systoleColor : $diastoleColor}
              />
            );
          })}
        </linearGradient>
      </defs>

      <Recharts.Line
        area-label={'line'}
        dot={(props: ICustomDotProps): React.ReactElement => {
          const { key, ...otherProps } = props;
          return (
            <CustomDot
              key={key}
              {...otherProps}
              disabled={!isImagesLoadingCompleted}
              radius={PhaseCurveDotRadius.Default}
            />
          );
        }}
        type="monotone"
        isAnimationActive={!grabbedReferenceLine}
        animationDuration={500}
        dataKey="weight"
        stroke={isImagesLoadingCompleted ? `url(#${curveColorId})` : theme.customPalette.objects.disabled}
        strokeWidth={1}
        activeDot={
          !(isReferenceLinePicked || grabbedReferenceLine)
            ? (props: DotProps): React.ReactElement => {
              const cdProps = props as ICustomDotProps;
              const { key, ...otherProps } = cdProps;
              return (
                <CustomDot
                  key={key}
                  {...otherProps}
                  disabled={!isImagesLoadingCompleted}
                  inverted={true}
                  radius={PhaseCurveDotRadius.Active}
                  sw={2}
                />
              );
            }
            : false
        }
      />
    </>
  );
};
